import { useEffect } from 'react';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertJsonLd(data: unknown) {
  const existing = document.head.querySelector('script[data-seo-jsonld]');
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', '1');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

type SeoProps = {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLd?: unknown;
};

export default function Seo({ title, description, keywords, canonical, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    upsertMeta('name', 'description', description);
    if (keywords) upsertMeta('name', 'keywords', keywords);
    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
    if (jsonLd) upsertJsonLd(jsonLd);
  }, [title, description, keywords, canonical, jsonLd]);

  return null;
}